export default __webpack_public_path__ + "static/media/home_mp4_image.eeade6a1.png";